import { NodoTipo } from "@/api";
import { TFunction } from "i18next";

export type NodoTipoLabel = {
  label: (t: TFunction) => string;
  labelWithNewPrefix: (t: TFunction) => string;
  labelCreated: (t: TFunction) => string;
};

export const NodoTipoLabel: { [tipo in NodoTipo]: NodoTipoLabel } = {
  Azienda: {
    label: (t) => t("nodi.tipi.Azienda.label"),
    labelWithNewPrefix: (t) => t("nodi.tipi.Azienda.labelNuovo"),
    labelCreated: (t) => t("nodi.tipi.Azienda.labelCreato"),
  },
  Contenitore: {
    label: (t) => t("nodi.tipi.Contenitore.label"),
    labelWithNewPrefix: (t) => t("nodi.tipi.Contenitore.labelNuovo"),
    labelCreated: (t) => t("nodi.tipi.Contenitore.labelCreato"),
  },
  Dispositivo_Macchinario: {
    label: (t) => t("nodi.tipi.Dispositivo_Macchinario.label"),
    labelWithNewPrefix: (t) =>
      t("nodi.tipi.Dispositivo_Macchinario.labelNuovo"),
    labelCreated: (t) => t("nodi.tipi.Dispositivo_Macchinario.labelCreato"),
  },
  Dispositivo_Sensore: {
    label: (t) => t("nodi.tipi.Dispositivo_Sensore.label"),
    labelWithNewPrefix: (t) => t("nodi.tipi.Dispositivo_Sensore.labelNuovo"),
    labelCreated: (t) => t("nodi.tipi.Dispositivo_Sensore.labelCreato"),
  },
  Gateway: {
    label: (t) => t("nodi.tipi.Gateway.label"),
    labelWithNewPrefix: (t) => t("nodi.tipi.Gateway.labelNuovo"),
    labelCreated: (t) => t("nodi.tipi.Gateway.labelCreato"),
  },
  Ripetitore: {
    label: (t) => t("nodi.tipi.Ripetitore.label"),
    labelWithNewPrefix: (t) => t("nodi.tipi.Ripetitore.labelNuovo"),
    labelCreated: (t) => t("nodi.tipi.Ripetitore.labelCreato"),
  },
};
